import {doPublicRequest} from './baseapi-service';

const URL = 'https://viacep.com.br/ws/';

export const buscaViaCep = (cep) => {
    const resource = cep + '/json/'
    return doPublicRequest(URL,resource,'GET')
}